import { Box, styled } from '@mui/material';

export const CourseHeaderBannerHighlightCoverStyle = styled(Box)`
  position: relative;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 487px;
    height: 286px;
  }
`;
